import React from 'react';
import { IHeaderCellProps } from './types';

const HeaderCell = (props: IHeaderCellProps): React.ReactElement => {
  return <>{props.children}</>;
};

export default HeaderCell;
